import { DirectApply } from '@fairygodboss/ui';
import React, { useState, useEffect } from 'react';
import { v4 as uuid } from 'uuid';

import { SnowplowImpressionTracker } from '../../../Analytics/Snowplow/SnowplowImpressionViewTracker';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';
import { useJobSearchContext } from '../../../../contexts/JobSearchContext';
import { PageContext } from '../../../../contexts/ContextCreator';
import { LOGIN_LAYOUT } from '../../../Login/LoginLayoutComponent/Layouts/LogInLayout/constants';

const getSnowplowCookieIds = () => {
    const cookies = document.cookie.split(';').map((x) => x.split('='));
    const spCookie = cookies.find((x) => x[0].includes('sp_id'));
    const spIds = spCookie?.[1]?.split('.') ?? false;
    return spIds ? spIds[0] : null;
};
const directApplyUrl = '/api/directApply';

const DirectApplyModal = () => {
    const pageKey = useState(uuid());
    const [directApplyJob, setDirectApplyJob] = useState({});
    const {
        isDirectApplyOpen,
        setIsDirectApplyOpen,
        isAuthenticatedUser,
        setHasApplied,
        singleJobDetail,
        fullSearchQueryId,
    } = useJobSearchContext();

    const { modalTrigger, pageProps } = React.useContext(PageContext);
    const { auth0, redirectUri, url } = pageProps;
    useEffect(() => {
        if (singleJobDetail?.jobDetails && singleJobDetail?.company) {
            const job = singleJobDetail?.jobDetails;
            const company = singleJobDetail?.company;
            const newdDirectApplyJob = {
                id: job.id,
                hash: job.slug,
                title: job.title,
                url: job.applyUrl,
                company: company.companyName,
                companyId: job.companyId,
                location: job.locationName,
            };

            setDirectApplyJob(newdDirectApplyJob);
        }
    }, [singleJobDetail]);
    return (
        <DirectApply
            isOpen={isDirectApplyOpen}
            onSignUp={() => {
                setIsDirectApplyOpen(false);
                window.location.reload();
            }}
            onClose={() => {
                setIsDirectApplyOpen(false);
            }}
            onLoginPressed={() => {
                setIsDirectApplyOpen(false);
                setTimeout(() => {
                    modalTrigger('authModal', {
                        auth0,
                        layoutType: LOGIN_LAYOUT,
                        redirectUri,
                        currentPath: url.path,
                        loginRedirectPath: url.path,
                    });
                }, 50);
            }}
            onSubmitClicked={() => {
                setHasApplied(true);
            }}
            directApplyUrl={directApplyUrl}
            snowPlowId={getSnowplowCookieIds()}
            job={directApplyJob}
            emitImpression={(metric) => {
                const newMetric = {
                    ...metric,
                    modalType: 'direct_apply',
                    component: 'modal',
                    position: 'pop_up',
                    pageType: 'collection',
                    pageSection: 'search',
                    impressionCardType: true,
                    isSponsored: !!singleJobDetail?.jobDetails?.isSponsored,
                    searchId: `${fullSearchQueryId}`,
                    companyId: singleJobDetail?.company?.companyId,
                    cardEntityId: singleJobDetail?.jobDetails?.slug,
                    cardType: 'job',
                };
                SnowplowImpressionTracker(newMetric);
            }}
            pageKey={pageKey[0]}
            emitMetric={(metric) => {
                const metricInfo = {};
                metricInfo.snowPlow = {
                    ...metric,
                    cardType: 'job',
                    pageType: 'collection',
                    pageSection: 'search',
                    isSponsored: !!singleJobDetail?.jobDetails?.isSponsored,
                    searchId: `${fullSearchQueryId}`,
                    companyId: singleJobDetail?.company?.companyId,
                    cardEntityId: singleJobDetail?.jobDetails?.slug,
                };
                EmitMetric(metricInfo);
            }}
            baseMetrics={{
                modalType: 'direct_apply',
            }}
            user={{
                isLoggedIn: isAuthenticatedUser,
            }}
        />
    );
};

export default DirectApplyModal;
